import { render, staticRenderFns } from "./OnlineQueryFormItem.vue?vue&type=template&id=33031fc4&scoped=true&"
import script from "./OnlineQueryFormItem.vue?vue&type=script&lang=js&"
export * from "./OnlineQueryFormItem.vue?vue&type=script&lang=js&"
import style0 from "./OnlineQueryFormItem.vue?vue&type=style&index=0&id=33031fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33031fc4",
  null
  
)

export default component.exports